import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import {
  blackColor,
  greenColor08,
  lightOrange07,
  whiteColor,
} from "configs/styles/muiThemes";
import { scrollBox } from "utils/styleUtility";

const MobileFeaturedCategories = ({ productsGroup }) => {
  const CategoryCard = ({ category }) => (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <Box
        sx={{
          backgroundColor: lightOrange07,
          borderRadius: "10px",
          p: "7px",
        }}
      >
        {/* Category Items Grid */}
        <Grid container spacing={1.5}>
          {category?.products?.slice(0, 4)?.map((item, index) => (
            <Grid item xs={6} key={index}>
              <Box
                component="img"
                src={item?.productPhoto?.[0]?.docURL}
                sx={{
                  width: "100%",
                  height: "30px",
                  backgroundColor: whiteColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  borderRadius: "5px",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Category Info */}
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: 600,
          color: blackColor,
          mt: 0.8,
          lineHeight: "16px",
        }}
      >
        {category?.subCatValue}
      </Typography>
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 500,
          color: "#777C8A",
          lineHeight: "16px",
        }}
      >
        {category.products?.length} products
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ p: "10px 16px 0" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: 14.5,
            fontWeight: 600,
            color: blackColor,
          }}
        >
          Featured Categories
        </Typography>
        <Link
          href={`/${sessionStorage.getItem("businessName")}/catalog`}
          sx={{
            fontSize: "12px",
            color: greenColor08,
            textDecoration: "none",
            fontWeight: 500,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          See all
        </Link>
      </Box>

      {/* Categories Grid */}
      <Grid container spacing={2}>
        {productsGroup?.slice(0, 3)?.map((category, index) => (
          <Grid item xs={4} sm={6} md={4} key={index}>
            <CategoryCard category={category} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MobileFeaturedCategories;
